import { render, staticRenderFns } from "./app-startpage.vue?vue&type=template&id=314f2cc6"
import script from "./app-startpage.vue?vue&type=script&lang=js"
export * from "./app-startpage.vue?vue&type=script&lang=js"
import style0 from "./app-startpage.vue?vue&type=style&index=0&id=314f2cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports